import styled from 'styled-components';

export const StyledArticlesLayout = styled.div`
  background-color: white;
  color: black;
`;
